import { Controller, useFormContext } from 'react-hook-form';
import { AddressSearch } from '@ui';
import { noop } from 'lodash-es';
import { MdOutlinePlace } from 'react-icons/md';
import { CaseFormType } from '@features/forms/CaseForms/schema';
import { useCaseFacilityAddress } from '../hooks/useCaseFacilityAddress';

export type CaseFacilityInputsProps = {
  disabled?: boolean;
  fieldName: 'hospitalCustomLocation' | 'txCenterCustomLocation';
  label: string;
};

export const CaseFacilityAddress = ({ disabled, fieldName, label }: CaseFacilityInputsProps) => {
  const { control, trigger } = useFormContext<CaseFormType>();
  const { addressValue, addressList, onItemSelect, onInputChange } = useCaseFacilityAddress(fieldName);

  const onBlur = () => trigger(`${fieldName}.addressId`);

  return (
    <div className="flex-[50%]">
      <Controller
        name={`${fieldName}.addressId`}
        control={control}
        render={({ fieldState: { invalid, error } }) => (
          <AddressSearch
            isDisabled={disabled}
            addressList={addressList}
            onAddressSelect={onItemSelect}
            onAddressInputChange={onInputChange}
            value={addressValue}
            onChange={noop}
            onBlur={onBlur}
            inputProps={{ placeholder: label, startContent: <MdOutlinePlace size={20} className="text-base-30" /> }}
            isInvalid={invalid}
            errorMessage={error?.message}
          />
        )}
      />
    </div>
  );
};
